<nz-modal
  (nzOnCancel)='onHide()'
  (nzOnOk)='update()'
  [nzClosable]='true'
  [nzOkDisabled]='form.invalid'
  [nzVisible]='show'
  nzOkText='Save Changes'
>
  <div *nzModalTitle><span class='fe fe-edit'></span> Edit your company name</div>
  <div *nzModalContent>
    <app-error-display *ngIf="showError() && errorDetails" [error]="errorDetails" (dismiss)="onDismissError()" (retry)="update()"></app-error-display>
    <form [formGroup]='form' class='grid grid-cols-1 gap-4' nz-form nzLayout='vertical'>
      <nz-form-item>
        <nz-form-label nzRequired>Company Name</nz-form-label>
        <nz-form-control>
          <input formControlName="companyName" nz-input type="text" />
        </nz-form-control>

      </nz-form-item>

    </form>
  </div>
</nz-modal>
